import React from 'react';
import classnames from 'classnames';

import MemoryFilesGridItemPreview from './FilesGridItemPreview';

import { getFileProgress } from '../../helpers/file';

import type { Asset } from '../../types/asset';

interface MemoryFilesGridItemProps {
  file: Asset;
  handleRemoveFile: (fileId: string) => void;
};

const MemoryFilesGridItem: React.FC<MemoryFilesGridItemProps> = ({ file, handleRemoveFile }) => {
  return (
    <div className={classnames('memory-files-grid-item', { error: file.error })}>
      <MemoryFilesGridItemPreview file={file} />
      <wa-button
        appearance="accent"
        size="xs"
        className="memory-files-grid-item-remove"
        onClick={() => handleRemoveFile(file.id)}
      >
        <wa-icon name="close" label="Remove"></wa-icon>
      </wa-button>
      {(file.progress && !file.progress.uploadComplete) && (
        <wa-progress-bar
          className="memory-files-grid-item-progress"
          value={getFileProgress(file)}
          label="Upload progress"
          style={{ '--track-height': '6px' } as Record<string, string>}
        ></wa-progress-bar>
      )}
    </div>
  );
}

export default MemoryFilesGridItem;
